import React, { useState, useEffect, useCallback } from 'react';
import { InputText, DropdownField, PrimeChips } from 'components/common/input';
import BaseModalForm from 'components/common/modal/BaseModalForm';
import ImageGallery from 'components/admin/common/ImageGallery';
import { Alert } from 'react-bootstrap';
import { useFormHandlers } from 'core/hooks/form/formHandlers';
import { MODAL_FORM_ERRORS } from 'core/constant/MODAL_FORM_ERRORS';
import { iconOptions } from 'core/config/iconOptions';

const EditProductModal = ({ show, product, handleClose, handleSave, updating, errors, deleteMediaItem, requestError, initialImages, categoriesOptions, productHelpOptions }) => {
  const [formValues, setFormValues] = useState([]);
  const [galleryImages, setGalleryImages] = useState(initialImages);
  const [internalFeatures, setInternalFeatures] = useState([]);
  const [featuresToDelete, setFeaturesToDelete] = useState([]);
  const { handleChange } = useFormHandlers(setFormValues);

  useEffect(() => {
    setFormValues(product);
    setGalleryImages(initialImages);
    setFeaturesToDelete([]);
    setInternalFeatures(product?.details || [{ label: "", attribute: "" }]);
  }, [product, initialImages]);

  const handleSaveClick = useCallback(() => {
    handleSave({ ...formValues, id: product?.id }, galleryImages, internalFeatures, featuresToDelete);
  }, [formValues, product?.id, handleSave, galleryImages, internalFeatures, featuresToDelete]);

  const handleFeatureChange = (index, key, value) => {
    const newFeatures = [...internalFeatures];
    newFeatures[index] = { ...newFeatures[index], [key]: value };
    setInternalFeatures(newFeatures);
  };

  const addFeature = () => {
    setInternalFeatures([...internalFeatures, { label: "", attribute: "" }]);
  };

  const removeFeature = (index) => {
    const feature = internalFeatures[index];
    if (feature.id) {
      setFeaturesToDelete([...featuresToDelete, feature.id]);
    }
    setInternalFeatures(internalFeatures.filter((_, i) => i !== index));
  };

  return (
    <BaseModalForm show={show} title={product?.id ? "Editar Producto" : "Crear Producto"} handleClose={handleClose} handleSave={handleSaveClick} updating={updating}>
      <div className="row">
        <div className="col-md-6 form-group">
          <InputText
            label="Título"
            value={formValues?.title}
            onChange={(e) => handleChange('title', e.target.value)}
            placeholder="Ingrese el título del producto"
            error={errors?.title}
          />
        </div>
        <div className="col-md-6 form-group">
          <InputText
            label="Descripción"
            value={formValues?.description}
            onChange={(e) => handleChange('description', e.target.value)}
            placeholder="Ingrese la descripción del producto"
            error={errors?.description}
          />
        </div>
        <div className="col-md-12 form-group">
          <DropdownField
            label="Video Guia"
            value={formValues?.help_id}
            options={productHelpOptions || []}
            onChange={(e) => handleChange('help_id', e.value)}
            placeholder="Seleccione el video Guía"
            error={errors?.help_id}
          />
        </div>
        <div className="col-md-6 form-group">
          <DropdownField
            label="Categoría"
            value={formValues?.category_id}
            options={categoriesOptions}
            onChange={(e) => handleChange('category_id', e.value)}
            placeholder="Seleccione la categoría del producto"
            error={errors?.category_id}
          />
        </div>
        <div className="col-md-6 form-group">
          <PrimeChips
            label="Tags"
            value={formValues?.tags}
            onChange={(e) => handleChange('tags', e.value)}
            placeholder="Ingrese los tags del producto"
            error={errors?.tags}
          />
        </div>

        <section className="m-0 p-0">
          <div className="row">
            <div className="col-12 form-group d-flex justify-content-between align-items-center">
              <h4>Aplicaciónes Relacionadas</h4>
              {internalFeatures && internalFeatures.length === 0 && (
                <button className="btn btn-primary-400 ms-3 my-3" type="button" onClick={addFeature}>
                  <i className="fa fa-plus-circle me-2" aria-hidden="true" />
                  Añadir Aplicación
                </button>
              )}
            </div>
            {internalFeatures?.map((feature, index) => (
              <React.Fragment key={index}>
                <div className="col-md-6">
                  <DropdownField
                    label="Icono"
                    value={feature.attribute}
                    options={iconOptions}
                    onChange={(e) => handleFeatureChange(index, 'attribute', e.value)}
                    placeholder="Seleccione la categoría del producto"
                    error={errors[index]?.attribute}
                  />
                </div>
                <div className="col-md-4">
                  <InputText
                    name="label"
                    label="Nombre del Valor"
                    value={feature.label}
                    onChange={(e) => handleFeatureChange(index, 'label', e.target.value)}
                    error={errors[index]?.label}
                  />
                </div>
                <div className="col-md-2">
                  <div className="d-flex justify-content-end align-items-center h-100">
                    <i className={feature.icon} style={{ fontSize: '24px', marginRight: '10px' }} />
                    <button
                      type="button"
                      onClick={() => removeFeature(index)}
                      className="delete-table delete-button me-2"
                    >
                      <i className="fa fa-trash" />
                    </button>
                    <button
                      type="button"
                      onClick={addFeature}
                      className="delete-table succes-button"
                    >
                       <i className="fa fa-plus-circle" aria-hidden="true" />
                    </button>
                  </div>
                </div>
              </React.Fragment>
            ))}
          </div>
        </section>
        <div className="col-12 form-group">
          <h4>Galería de Imágenes del Producto</h4>
          <ImageGallery initialImages={galleryImages} onImagesChange={setGalleryImages} onDeleteImage={deleteMediaItem} />
        </div>
        <div className="col-12 form-group mt-3">
          {requestError &&
            <Alert variant="danger">
              {requestError?.response?.data?.message ||
               MODAL_FORM_ERRORS.PRODUCT}
            </Alert>
          }
        </div>
      </div>
    </BaseModalForm>
  );
};

export default React.memo(EditProductModal);
